export type BrandSize = "default" | "compact";

export const brandCopy = {
  name: "QIMAH TECH",
  tagline: "Software Solutions",
};
